import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@material-ui/core'
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonAddHLPure,
  ButtonHLPure,
  LabelModalPure,
} from '../../pures'
import { ClientDocument } from '../../../services'
import {
  HeaderHLPure,
  FilterHLPure,
  DialogSystemGLPure,
  SearchBarHLPure,
  DialogYesNoHLPure,
  GridSelectionHLPure,
  DropDownBtnHLPure
} from '../../pures'
import './documents-to-require.css'
import DocumentsToRequireConfigurationView from './documents-to-require-pages/documents-to-require-configurations.view'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import moment from 'moment'
import { convertToStandarDate } from '../../../utils'

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t('documentsToRequire.grid.documents')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
}

const CellColumnName = (props) => {
  return (
    <td className='manageAssemblyView-grid-col1'>
      <div className='documents-to-require-grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{props.dataItem.name}</p>
        <p className='grid-cell-subtitles'>{props.dataItem.newUpdatedDate}</p>
      </div>
    </td>
  )
}

const CellColumnBtns = (props) => {
  const { t, handleChangePage, toggleDialogYesNo, dataItem } = props
  const showBtnDelete = dataItem.defaultDocument ? false : true
  const is450 = useMediaQuery('(max-width:450px)')

  return (
    <td>
      <div className='grid-btn-div'>
        <button className='grid-btn-action' onClick={() => handleChangePage(true, t('documentsToRequire.grid.detail'), dataItem)}>
          <p>{t('assembliesPrincipalView.grid.btns.detail')}</p>
        </button>
        {
          showBtnDelete && (
            <button className='grid-btn-action' onClick={() => toggleDialogYesNo(dataItem, true)}>
              <p>{t('documentsToRequire.grid.delete')}</p>
            </button>
          )
        }
      </div>

      {is450 && (
        <div className='grid-btn-arrow-mobile' onClick={() => handleChangePage(true, t('documentsToRequire.grid.detail'), dataItem)}>
          <img alt='assemblies-arrow' src={ArrowBtnMobile} />
        </div>
      )}
    </td >
  )
}

const DocumentsToRequireView = (props) => {
  const {
    documents,
    loading,
    showLoadingRequesting,
    toggleLoadingRequesting,
    toggleErrorRequesting,
    showCompletedRequesting,
    toggleCompletedRequesting,
    showErrorRequesting,
    toggleErrorRequestingFalse,
    messageError,
    personTypes,
    goBackRoute,
    token,
    language
  } = props
  const { t } = useTranslation()

  const [dataUserFiltered, setDataUserFiltered] = useState([])
  const [selectedValueFilter, setSelectedValue] = useState(t('documentsToRequire.document.type.key.all'))
  const [searchValue, setSearchValue] = useState('')
  const [selectedUser, setSelectedUser] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [nameComponentUser, setNameComponentUser] = useState('')
  const [titleHeader, setTitleHeader] = useState(t('documentsToRequire.titleHeader'))

  const [dataItemUser, setDataItemUser] = useState({})
  const [showDialogYesNo, setShowDialogYesNo] = useState(false)

  const clientId = props?.user?.userMetaData?.userMifirma?.clientId || 0

  const is1500 = useMediaQuery('(max-width:1500px)')
  const is1360 = useMediaQuery('(max-width:1360px)')
  const is1200 = useMediaQuery('(max-width:1200px)')
  const is1000 = useMediaQuery('(max-width:1000px)')
  const is820 = useMediaQuery('(max-width:820px)')
  const is650 = useMediaQuery('(max-width:650px)')
  const is560 = useMediaQuery('(max-width:560px)')
  const is450 = useMediaQuery('(max-width:450px)')

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let CellColumnOne = (props) => <CellColumnName {...props} t={t} />
  let CellColumnTwo = (props) => <CellColumnBtns {...props} t={t} handleChangePage={handleChangePage} toggleDialogYesNo={toggleDialogYesNo} />

  let widthCellOne = '220px'
  let widthCellTwo = '40px'

  if (is1500) widthCellOne = '180px'
  if (is1360) widthCellOne = '140px'
  if (is1200) widthCellOne = '120px'
  if (is1000) widthCellOne = '90px'
  if (is820) widthCellOne = '65px'
  if (is650) widthCellOne = '50px'
  if (is560) widthCellOne = '180px'
  if (is450) widthCellOne = '160px'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (!documents || documents.length === 0) return
    const copyDocuments = [...documents]
    const filteredDocuments = filterData(copyDocuments, selectedValueFilter, searchValue)

    setDataUserFiltered(filteredDocuments)
  }, [documents])


  useEffect(() => {
    const copyDocuments = [...documents]
    const filteredDocuments = filterData(copyDocuments, selectedValueFilter, searchValue)

    setDataUserFiltered(filteredDocuments)
  }, [searchValue, selectedValueFilter])

  const searchChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
  }

  const onHandlerFilter = (e) => {
    const value = e.target.value
    setSelectedValue(value)
  }

  //DialogYesNoHLpure funtion to show o not show
  const toggleDialogYesNo = (dataItem, value) => {
    setDataItemUser(dataItem)
    setShowDialogYesNo(value)
  }

  const filterData = (copyDocuments, valueFilter, valueSearch) => {
    let filteredDocuments = copyDocuments

    if (valueFilter !== t('documentsToRequire.document.type.key.all')) {
      filteredDocuments = filteredDocuments.filter(
        (doc) => doc.keyDocument === valueFilter
      )
    }

    if (valueSearch) {
      const search = valueSearch.toLowerCase()
      filteredDocuments = filteredDocuments.filter(
        (doc) => doc.name.toLowerCase().includes(search)
      )
    }

    return filteredDocuments
  }

  const createClientDocument = async (clientDocumentInformation, token) => {
    toggleLoadingRequesting(true)
    try {
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      )

      let data = new FormData()
      data.append('clientId', Number(clientId))
      data.append('documentPersonTypeId', clientDocumentInformation.documentPersonTypeId)
      data.append('nombre', clientDocumentInformation.nombre)
      data.append('description', clientDocumentInformation.description)
      data.append('defaultDocument', false)
      data.append('clientDocumentTypeRequestId', clientDocumentInformation.clientDocumentTypeRequestId)
      data.append('sendOCR', clientDocumentInformation.sendOCR)
      data.append('typeDocumentName', clientDocumentInformation.typeDocumentName)
      data.append('documentForm', clientDocumentInformation.documentForm)
      let res = await clientDocument.createClientDocument(data, token)
      if (res && res.data.statusCode === 200) {
        let documentsDB = await clientDocument.getClientDocumentA3Cloud(Number(clientId), token)
        moment.locale(language)
        const documents = documentsDB.data.data
        const allDocuments = documents.map((documento) => {
          let convertDate = convertToStandarDate(documento.updatedDateBD, language)
          const standarDate = (convertDate !== 'invalid date') ? convertDate : documento.updatedDate
          documento.newUpdatedDate = `${t('documentsToRequire.grid.modifiedOn')} ${standarDate}`
          if (documento.clientDocumentTypeRequest === null && documento.clientDocumentTypeRequestId === null) {
            documento.clientDocumentTypeRequestId = 0
            documento.clientDocumentTypeRequest = { name: 'Sin definir' }
          }

          return documento
        })

        toggleLoadingRequesting(false)
        await toggleCompletedRequesting(
          true,
          '',
          allDocuments
        )
        setTimeout(() => {
          handleChangePage(false, '')
        }, 4000)
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(t('documentsToRequire.errors.create.document'), 4000, false, '/')
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(t('documentsToRequire.errors.create.document'), 4000, false, '/')
    }
  }

  const deleteClientDocument = async () => {
    toggleLoadingRequesting(true)
    toggleDialogYesNo(dataItemUser, true)
    try {
      toggleDialogYesNo(dataItemUser, false)
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      )
      let res = await clientDocument.deleteClientDocument(
        dataItemUser.id,
        props.token
      )

      if (res && res.status === 200) {
        let documentsDB = await clientDocument.getClientDocumentA3Cloud(Number(clientId), token)
        moment.locale(language)
        const documents = documentsDB.data.data
        const allDocuments = documents.map((documento) => {
          let convertDate = convertToStandarDate(documento.updatedDateBD, language)
          const standarDate = (convertDate !== 'invalid date') ? convertDate : documento.updatedDate
          documento.newUpdatedDate = `${t('documentsToRequire.grid.modifiedOn')} ${standarDate}`
          if (documento.clientDocumentTypeRequest === null && documento.clientDocumentTypeRequestId === null) {
            documento.clientDocumentTypeRequestId = 0
            documento.clientDocumentTypeRequest = { name: 'Sin definir' }
          }

          return documento
        })

        toggleLoadingRequesting(false)
        await toggleCompletedRequesting(
          true,
          '',
          allDocuments
        )
        if (nameComponentUser === t('documentsToRequire.grid.detail')) {
          setTimeout(() => {
            handleChangePage(false, '')
          }, 4000)
        }
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(t('documentsToRequire.errors.delete.document'), 4000, false, '/help-desk')
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(t('documentsToRequire.errors.delete.document'), 4000, false, '/help-desk')
      return false
    }
  }

  const updateClientDocument = async (clientDocumentInformation, token) => {
    toggleLoadingRequesting(true)
    try {
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      )

      let data = new FormData()
      data.append('id', clientDocumentInformation.id)
      data.append('nombre', clientDocumentInformation.nombre)
      data.append('description', clientDocumentInformation.description)
      data.append('clientDocumentTypeRequestId', clientDocumentInformation.clientDocumentTypeRequestId)
      data.append('sendOCR', clientDocumentInformation.sendOCR)
      data.append('typeDocumentName', clientDocumentInformation.typeDocumentName)
      data.append('documentForm', clientDocumentInformation.documentForm)

      let res = await clientDocument.updateClientDocument(data, token)
      if (res && res.data.statusCode === 200) {
        let documentsDB = await clientDocument.getClientDocumentA3Cloud(Number(clientId), token)
        moment.locale(language)
        const documents = documentsDB.data.data
        const allDocuments = documents.map((documento) => {
          let convertDate = convertToStandarDate(documento.updatedDateBD, language)
          const standarDate = (convertDate !== 'invalid date') ? convertDate : documento.updatedDate
          documento.newUpdatedDate = `${t('documentsToRequire.grid.modifiedOn')} ${standarDate}`
          if (documento.clientDocumentTypeRequest === null && documento.clientDocumentTypeRequestId === null) {
            documento.clientDocumentTypeRequestId = 0
            documento.clientDocumentTypeRequest = { name: 'Sin definir' }
          }

          return documento
        })

        toggleLoadingRequesting(false)
        await toggleCompletedRequesting(
          true,
          '',
          allDocuments
        )
        setTimeout(() => {
          handleChangePage(false, '')
        }, 4000)
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(t('documentsToRequire.errors.create.document'), 4000, false, '/')
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(t('documentsToRequire.errors.create.document'), 4000, false, '/')
    }
  }

  const handleChangePage = (show, page, documentSelected) => {
    setShowDetails(show)
    setNameComponentUser(page)
    setSelectedUser(documentSelected)

    let title = t('documentsToRequire.titleHeader')
    if (page === t('documentsToRequire.newDocument')) title = t('documentsToRequire.addDocumentTitle')
    if (page === t('documentsToRequire.grid.detail')) title = t('documentsToRequire.documentDetailsTitle')
    setTitleHeader(title)
  }

  if (loading) return <SimpleLoading />

  return (
    <div className='standard-wrapper'>
      <div className='documentsToRequire-header'>
        <HeaderHLPure title={titleHeader} />
      </div>
      {
        showDetails &&
          nameComponentUser &&
          nameComponentUser !== t('documentsToRequire.grid.delete') ? (
          <DocumentsToRequireConfigurationView
            {...props}
            nameComponentUser={nameComponentUser}
            selectedUser={selectedUser}
            selectedValueFilter={selectedValueFilter}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            token={props.token}
            clientId={clientId}
            rolesBySignatureProfile={props.rolesBySignatureProfile}
            validators={props.validators}
            forceRefresh={props.forceRefresh}
            typeDocuments={props.typeDocuments}
            preferenceValue={props.preferenceValue}
            newOptions={props.newOptions}
            handleChangePage={handleChangePage}
            deleteClientDocument={deleteClientDocument}
            createClientDocument={createClientDocument}
            updateClientDocument={updateClientDocument}
            toggleDialogYesNo={toggleDialogYesNo}
          />
        ) : (
          <div className='documentsToRequire-principalView'>

            <div className='documentsToRequire-navbar'>
              <ButtonAddHLPure
                nameBtn={t('documentsToRequire.newDocument')}
                iconAdd
                onClickBtn={() => handleChangePage(true, t('documentsToRequire.newDocument'), {})}
              />
              <SearchBarHLPure
                placeholder={t('documentsToRequire.searchBarPlaceHolder')}
                onSearchChange={(e) => searchChange(e)}
              />
              <FilterHLPure
                options={personTypes}
                nameOption='personType'
                valueItem='name'
                onFilterChange={(e) => onHandlerFilter(e)}
                optionsValue={selectedValueFilter}
              />
            </div>
            <div className='documentsToRequire-grid'>
              <GridSelectionHLPure
                styleGeneral={false}
                pageable={true}
                skip={0}
                take={6}
                dataGrid={dataUserFiltered}

                titleRow1={t('documentsToRequire.grid.documents')}
                headerColumnOne={AllHeadersColumns}
                cellColumnOne={CellColumnOne}
                widthColumnOne={widthCellOne}
                minResizableWidth1={widthCellOne}

                columnTwo={true}
                titleRow2={t('documentsToRequire.grid.actions')}
                headerColumnTwo={AllHeadersColumns}
                cellColumnTwo={CellColumnTwo}
                widthColumnTwo={widthCellTwo}
                minResizableWidth2={'auto'}

                styleGrid={{ height: 'auto' }}
              />
            </div>
          </div>
        )
      }
      {showDialogYesNo && (
        <DialogYesNoHLPure
          titleDialog={t('documentsToRequire.dialogDeleteDocumenTitle')}
          textBtnCancel={t('documentsToRequire.dialogCancelButton')}
          saveBtn={t('documentsToRequire.dialogDeleteDocumentButton')}
          cancel={toggleDialogYesNo}
          handleSubmit={deleteClientDocument}
          textBtnCancelDisabled={false}
        >
          <div className='documentsToRequire-modal-delete'>
            <LabelModalPure label={t('documentsToRequire.dialogConfirmDeleteText')} />
          </div>
        </DialogYesNoHLPure>
      )}
      {!nameComponentUser &&
        <div className='documentsToRequire-returnButton'>
          <ButtonHLPure
            nameBtn={t('button.return')}
            onClickBtn={() => props.history.push(goBackRoute)}
          />

        </div>
      }
      <div className='documentsToRequire-footer'>
        <PromotionalFooterPure />
      </div>
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}

        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}

        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleErrorRequestingFalse}
        messageError={messageError}
      />
    </div>
  )
}

export default DocumentsToRequireView
